import React from 'react'
import Logo from '../logo/Logo';
import './about.css';
import { Typography } from '@mui/material';

export default function About() {
  return (
    <div className='about'>
        <div className='about-img'>
            <Logo />
        </div>
        <div className='para'>
            <div className= "para-flex">
                <div className='flex-item'>
                    <div className='about-heading'>
                        <Typography
                        variant='body1'
                        fontSize='45px'
                        fontFamily='Arial'
                        >We are
                        </Typography>
                        <Typography
                        variant="h3"
                        fontFamily='sans-serif'
                        fontSize='60px'
                        >Make <span style={{fontFamily:'Garamond', fontSize:'60px'}}>my</span> Trip</Typography>
                        <p>Nurtured from the seed of a single idea ‘to empower the traveller with easy & instant travel bookings providing comprehensive choices’, MakeMyTrip is a pioneer in India’s online travel space. Founded by Deep Kalra in the year 2000, MakeMyTrip began its journey by serving the US-India travel market with best-value products & services, powered by robust technology and round-the-clock customer support.</p>
                        <p>After successfully consolidating its position as a customer-first brand, known for its reliability and transparency, MakeMyTrip launched its India operations in 2005.</p>
                        <p>As low-cost flight carriers were introduced in India, the number of Indians opting</p>
                    </div>
                </div>
                <div className="flex-item">
                    <p>
                        for online travel solutions also increased rapidly. And MakeMyTrip answered the call of the hour, by bringing the convenience of booking flights, hotels, and holiday packages in just a few clicks.
                    </p>
                    <p>
                        Over the years, we have partnered with many leading brands from the aviation & hospitality industries, creating fruitful partner relations for business expansion opportunities. We also entered the homestays & villas and continue to procure increased market share market in the same. With this, we also entered the ground transport space and commenced offering cab, bus & train booking services.
                    </p>
                    <p>
                        What makes our story even stronger is the performance of our newly launched segments, like myBiz—our comprehensive business travel suite and myPartner—an exclusive platform for travel agents. Entering the Gulf market is our latest feat, where we offer power-packed deals on flights & hotels.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}
